export class ContainerBarChartDto{
    containers:number
    quantity:number
    constructor(containers:number,
        quantity:number){
            this.containers=containers;
            this.quantity=quantity
    }
}